import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default function RHFCKEditor({
  field,
  fieldState,
  label,
  maxHeight = 200,
  placeholder,
}) {
  return (
    <div className="form-group mb-3">
      {label && <label className="mb-2">{label}</label>}
      <div
        style={{
          border: fieldState?.error ? "1px solid red" : "1px solid #ced4da",
          borderRadius: "15px",
          overflow: "hidden",
        }}
      >
        <CKEditor
          onInit={(editor) => {
            editor.editing.view.change((writer) => {
              writer.setStyle(
                "height",
                "200px",
                editor.editing.view.document.getRoot()
              );
            });
          }}
          editor={ClassicEditor}
          data={field.value || ""}
          config={{
            toolbar: ["bold", "italic", "underline", "link"],
            placeholder: placeholder || "Enter text here...",
          }}
          onChange={(event, editor) => {
            let data = editor.getData();
          
            // Create a DOM parser to manipulate HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, "text/html");
          
            // Remove empty <p>, <div> etc. at the start and end
            const body = doc.body;
          
            // Helper: check if node is visually empty
            const isNodeEmpty = (node) =>
              !node.textContent.trim() && !node.querySelector("*");
          
            // Trim empty nodes from start
            while (body.firstChild && isNodeEmpty(body.firstChild)) {
              body.removeChild(body.firstChild);
            }
          
            // Trim empty nodes from end
            while (body.lastChild && isNodeEmpty(body.lastChild)) {
              body.removeChild(body.lastChild);
            }
          
            // Get cleaned HTML
            const cleanedData = body.innerHTML.trim();
          
            field.onChange(cleanedData);
          }}
          
          onBlur={() => field.onBlur()}
        />
      </div>
      {fieldState?.error && (
        <small className="text-danger">{fieldState.error.message}</small>
      )}
    </div>
  );
}
